import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA / offline shell.
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/sw.js").then((reg) => {
            // When a new SW takes control (after deploy), reload the page once so
            // the user picks up the fresh JS bundle automatically.
            let reloaded = false;
            navigator.serviceWorker.addEventListener("controllerchange", () => {
                if (reloaded) return;
                reloaded = true;
                window.location.reload();
            });
            // If the SW posts SW_UPDATED on activate, also reload defensively.
            navigator.serviceWorker.addEventListener("message", (event) => {
                if (event.data && event.data.type === "SW_UPDATED") {
                    if (reloaded) return;
                    reloaded = true;
                    window.location.reload();
                }
            });
            // Probe for a waiting worker right after registration and skip-waiting it.
            if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
            reg.addEventListener("updatefound", () => {
                const nw = reg.installing;
                if (!nw) return;
                nw.addEventListener("statechange", () => {
                    if (nw.state === "installed" && navigator.serviceWorker.controller) {
                        nw.postMessage({ type: "SKIP_WAITING" });
                    }
                });
            });
        }).catch((err) => {
            console.warn("SW registration failed:", err);
        });
    });
}
